import { format, isToday } from '@repo/date-time';
import { useCallback, useMemo, useState } from 'react';

const STORAGE_KEY = 'locationPermissionDismissed';

const isDismissedToday = (): boolean => {
  const dismissed = localStorage.getItem(STORAGE_KEY);
  return dismissed ? isToday(dismissed) : false;
};

const saveDismissedDate = (): void => {
  localStorage.setItem(STORAGE_KEY, format(new Date(), 'yyyy-MM-dd'));
};

export const useLocationPermission = () => {
  const [visible, setVisible] = useState<boolean>(() => !isDismissedToday());

  const dismiss = useCallback(() => {
    setVisible(false);
    saveDismissedDate();
  }, []);

  return useMemo(
    () => ({
      visible,
      dismiss,
    }),
    [visible, dismiss]
  );
};
